<template>
  <div class="zu-empty">
    <div class="zu-empty-img-box">
      <slot name="img">
        <img class="zu-empty-img" :src="imgSrc" :alt="text" />
      </slot>
    </div>
    <div class="zu-empty-text">{{text}}</div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
export default {
  name: "ZuEmpty",
  props: {
    text: { type: String, default: '暂无数据'},
    src: { type: String, default: ''}
  },
  computed: {
    imgSrc() {
      return this.src || '/img/data-d.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.zu {
  &-empty {
    padding-top: 40rem;
    padding-bottom: 40rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &-img {
      width: 350rem;
      height: 198rem;
      &-box {
        font-size: 0;
      }
    }
    &-text {
      margin-top: 20rem;
      font-size: 14rem;
      color: #999;
    }
  }
}
</style>
